import axios, { CancelToken } from 'axios';

import Component from '../core/Component';
import { annuityCalc } from '../models/CalculatorAnnuity';
import getModelRSTS from '../models/CalculatorLoanModelRSTS';
import getModelSS from '../models/CalculatorLoanModelSS';
import { queryAll } from '../utils/dom';
import { formatCurrency, formatPercentage } from '../utils/Number';

export default class CalculatorLoan extends Component {
    options = {
        type: 'reko',
        tarif: 'U152',
    }

    tarif = {
        U153: {
            kod: 119,
            sazbaSU: 0.0299,
            sazbaSporeni: 0.001,
            minimalniVklad: 0.17,
            dkoef: 'U',
            kUZ: 1.5,
            vyseKoef: 64,
            preklopeni: 35,
            prideleni: 24,
            splatkaCCSU: 'C',
            splatkaSU: 0.55,
            minSplatkaSU: 0,
            puvod: 'R',
        },
        U152: {
            kod: 118,
            sazbaSU: 0.035,
            sazbaSporeni: 0.005,
            minimalniVklad: 0.5,
            dkoef: 'U',
            kUZ: 1.5,
            vyseKoef: 64,
            preklopeni: 40,
            prideleni: 24,
            splatkaCCSU: 'C',
            splatkaSU: 1,
            minSplatkaSU: 0,
            puvod: 'R',
        },
        S151: {
            kod: 117,
            sazbaSU: 0.04,
            sazbaSporeni: 0.01,
            minimalniVklad: 0.3,
            dkoef: 'U',
            kUZ: 2.7,
            vyseKoef: 64,
            preklopeni: 40,
            prideleni: 24,
            splatkaCCSU: 'C',
            splatkaSU: 0.5,
            minSplatkaSU: 0,
            puvod: 'R',
        },
        U173: {
            kod: 'HYPO',
            sazbaSU: 0.0299,
            sazbaSporeni: 0.001,
            minimalniVklad: 0.1,
            dkoef: 'U',
            kUZ: 1.5,
            vyseKoef: 64,
            preklopeni: 20,
            prideleni: 24,
            splatkaCCSU: 'C',
            splatkaSU: 0.58,
            minSplatkaSU: 0,
            puvod: 'R',
        },
        U172: {
            kod: 'REKO',
            sazbaSU: 0.032,
            sazbaSporeni: 0.001,
            minimalniVklad: 0.3,
            dkoef: 'U',
            kUZ: 1.5,
            vyseKoef: 64,
            preklopeni: 40,
            prideleni: 24,
            splatkaCCSU: 'C',
            splatkaSU: 0.85,
            minSplatkaSU: 0,
            puvod: 'R',
        },
        U211: {
            kod: 'REKODRUZSTVO',
            sazbaSU: 0.031,
            sazbaSporeni: 0.001,
            minimalniVklad: 0.25,
            dkoef: 'U',
            kUZ: 1.5,
            vyseKoef: 64,
            preklopeni: 50,
            prideleni: 24,
            splatkaCCSU: 'C',
            splatkaSU: 0.58,
            minSplatkaSU: 0,
            puvod: 'R',
        },
    }

    type = {
        hypo: {
            sazba: 0.0439,
            poplatekPU: 0,
            poplatekSS: 0.01,
            dstiKoef: 0.45,
            dtiKoef: 9,
            pledge: 0.9,
        },
        reko: {
            sazba: 0.0529, //v kodu se dynamicky prepisuje
            sazba2: 0.0529, //v kodu se dynamicky prepisuje
            poplatekPU: 0.01,
            poplatekSS: 0.01,
            dstiKoef: 0.65,
            dtiKoef: 13,
            pledge: 1,
        },
        dotacniPoradenstvi: {
            // stejne jako reko, akorat jina sazba
            sazba: 0.0529, //v kodu se dynamicky prepisuje
            sazba2: 0.0529, //v kodu se dynamicky prepisuje
            poplatekPU: 0.01,
            poplatekSS: 0.01,
            dstiKoef: 0.65,
            dtiKoef: 13,
            pledge: 1,
        },
        rekoDruzstvo: {
            // stejne, jako reko, akorat jine koeficienty DT a DSTI
            sazba: 0.0509,
            poplatekPU: 0.01,
            poplatekSS: 0.01,
            dstiKoef: 0.5,
            dtiKoef: 10,
            pledge: 1,
        },
        zvyhodnenyUver: {
            // stejne, jako rekoDruzstvo, akorat jina sazba
            sazba: 0.0299,
            poplatekPU: 0.01,
            poplatekSS: 0.01,
            dstiKoef: 0.5,
            dtiKoef: 10,
            pledge: 1,
        },
    }

    constructor(element, options = {}) {
        super(element)

        this.options = {
            ...this.options,
            ...options,
        }

        this.ref = {
            rangeControls: [],
            output: null,
            duration: null,
            rate: null,
            // offerButton: null,
            income: null,
            pledge: null,
            printButton: null,
            sazba: null,
        }

        this.ready = false
    }

    prepare() {
        this.slideControls = this.ref.rangeControls.reduce((acc, element) => {
            acc[element.dataset.type] = Component.getFromElement(element)
            return acc
        }, {})

        this.slideControls.loan.on('change', this.handleLoanChange)
        this.slideControls.payment?.on('change', this.handlePaymentChange)
        this.slideControls.maturity?.on('change', this.handleMaturityChange)

        // this.ref.offerButton.addEventListener('click',  this.handleOfferButtonClick)
        this.ref.printButton &&
            this.ref.printButton.addEventListener('click', this.handlePrintButtonClick)

        this.updatePaymentRange({
            value: this.slideControls.loan.getValue(),
        })

        this.ready = true

        this.update()
    }

    handleLoanChange = (args) => {
        this.updatePaymentRange(args)
    }

    handlePaymentChange = () => {
        this.update()
    }
    
    handleMaturityChange = () => {
        this.update()
    }

    handlePrintButtonClick = (event) => {
        event.preventDefault()

        const data = this.getPrintData()

        if (this.requestCancel) {
            this.requestCancel()
        }

        axios({
            method: 'post',
            headers: {
                'X-Request': 'JSON',
                'X-Requested-With': 'XMLHttpRequest',
            },
            cancelToken: new CancelToken((cancel) => (this.requestCancel = cancel)),
            url: this.ref.printButton.href,
            data: data,
        }).then((response) => {
            if (response.status === 200) {
                window.open(response.data)
            }
        })
    }

    // handleOfferButtonClick = (event) => {
    //     event.preventDefault()

    //     const data = this.getData()

    //     EventBus.emit('calculator:button:click', {
    //         title: event.target.dataset.text || '',
    //         product: event.target.dataset.product || '',
    //         data: data,
    //     })
    // }

    updatePaymentRange = ({ value }) => {
        const CC = value

        if (this.options.type === 'reko' || this.options.type === 'dotacniPoradenstvi') {
            if (!this._originalSazba) {
                this._originalSazba = this.type[this.options.type].sazba
            }
            this.type[this.options.type].sazba =
                value < 600000 ? this.type[this.options.type].sazba2 : this._originalSazba
        }

        // zkontrolovat limity u mesicnich splatek
        const splatkaPU = ceil10((this.type[this.options.type].sazba * CC) / 12, 10)
        const dosporovani = (this.tarif[this.options.tarif].minimalniVklad * CC) / 100
        const zakladniSplatka = splatkaPU + dosporovani
        this.setPaymentRange(zakladniSplatka)
    }

    getPaymentRange(step) {
        return this.slideControls.payment?.getRange()
    }

    setPaymentRange(base) {
        const min = base
        const range = [base]
        const max = base * 3
        base = Math.ceil(base / 100) * 100
        range.push(base)

        while (base < max) {
            base += 100
            range.push(base)
        }

        this.slideControls.payment?.setOptions({
            translate: range.reverse(),
            range: [0, range.length - 1],
            step: 1,
            value: range.length - 1,
        })

        if (this.ref.sazba) {
            this.ref.sazba.innerHTML = `${`${
                Math.round(this.type[this.options.type].sazba * 10000) / 100
            }`.replace('.', ',')}&nbsp;%`
        }
    }

    update() {
        if (!this.ready) {
            return
        }
        const data = this.calc()

        this.ref.duration.innerHTML = this.formatOutput(data.delka)
        if (this.ref.income) {
            this.ref.income.innerHTML = formatCurrency(data.income)
        }
        if (this.ref.rate) {
            this.ref.rate.innerHTML = formatPercentage(data.sazbaPU)
        }
    }

    formatOutput(duration) {
        let years = Math.floor(duration / 12)
        let months = duration % 12

        let output = ''

        if (years === 1) {
            output = '1 rok'
        } else if (years > 4) {
            output = years + ' let'
        } else {
            output = years + ' roky'
        }

        if (months > 0) {
            output +=
                ' a ' + months + ' ' + (months == 1 ? 'měsíc' : months < 5 ? 'měsíce' : 'měsíců')
        }

        return output
    }

    getData() {
        const data = Object.keys(this.slideControls).reduce((acc, key) => {
            acc[key] = this.slideControls[key].getData()
            return acc
        }, {})

        return data
    }

    getPrintData() {
        const params = Object.keys(this.slideControls).map((key) => {
            const control = this.slideControls[key].element

            return {
                label: control.querySelector('.RangeControl-label').textContent.trim(),
                value: control.querySelector('.RangeControl-input').textContent.trim(),
            }
        })

        const values = queryAll('.calculator-Output-table tr', this.element).map((row) => ({
            label: row.querySelector('th').textContent.trim(),
            value: row.querySelector('td').textContent.trim(),
        }))

        const total = {
            label: 'Měsíční splátka',
            value: this.ref.duration.textContent,
        }

        const title = this.ref.printButton.dataset.title
        const example = this.ref.printButton.dataset.example

        return {
            total,
            values,
            params,
            title,
            example,
        }
    }

    showError() {
        this.ref.output.classList.add('has-error')
    }

    hideError() {
        this.ref.output.classList.remove('has-error')
    }

    annuityCalc() {
        var TARIF = this.options.tarif
        var CC = this.slideControls['loan'].getValue()
        var sazbaPU = this.type[this.options.type].sazba
        var poplatekSS = this.type[this.options.type].poplatekSS
        var vedeniUctuPU = 93
        var splatnost = this.slideControls['maturity'].getValue()

        return annuityCalc({
            CC,
            splatnost,
            sazbaPU,
            vedeniUctuUver: vedeniUctuPU,
            poplatekSS,
        })
    }

    calc() {
        var TARIF = this.options.tarif // fixni tarif, data jsou ale pro vsechny tri tarify - mozno rozsirit o volbu tarifu

        // vstupni hodnoty
        var CC = this.slideControls['loan'].getValue()

        // zakladni hodnoty pro vypocet modelu (vsechny nevypocetni hodnoty)
        var sazbaPU = this.type[this.options.type].sazba
        var sazbaSU = this.tarif[TARIF].sazbaSU
        var sazbaSS = this.tarif[TARIF].sazbaSporeni
        var splatkaPU = ceil10((sazbaPU * CC) / 12, 10)
        var dosporovani = (this.tarif[TARIF].minimalniVklad * CC) / 100
        var preklopeni = this.tarif[TARIF].preklopeni / 100

        var vyplata = 0
        var splatkaSU = 0
        if (this.tarif[TARIF].splatkaCCSU === 'C') {
            splatkaSU = (this.tarif[TARIF].splatkaSU * CC) / 100
        } else {
            splatkaSU = (this.tarif[TARIF].splatkaSU * (CC - vyplata)) / 100
        }

        var normovanyUrok = 0.03
        var koeficient = this.tarif[TARIF].kUZ
        var minUkazatel = this.tarif[TARIF].vyseKoef
        var kod = this.tarif[TARIF].kod
        var poplatekSS = this.type[this.options.type].poplatekSS
        var poplatekPU = this.type[this.options.type].poplatekPU
        var vedeniUctuSS = 88
        var vedeniUctuPU = 93
        var vypisSS = 0
        var vypisPU = 0

        // minimalni splatka
        var uzivatelskaSplatkaPU = this.slideControls['payment'].getValue()
        var realneDosporovani =
            uzivatelskaSplatkaPU > splatkaPU + dosporovani
                ? uzivatelskaSplatkaPU - splatkaPU
                : dosporovani
        var C22 = uzivatelskaSplatkaPU >= splatkaSU ? uzivatelskaSplatkaPU : splatkaSU

        // console.table([{
        //     CC: CC,
        //     sazbaPU: sazbaPU,
        //     sazbaSU: sazbaSU,
        //     sazbaSS: sazbaSS,
        //     splatkaPU: splatkaPU,
        //     dosporovani: dosporovani,
        //     realneDosporovani: realneDosporovani,
        //     preklopeni: preklopeni,
        //     splatkaSU: splatkaSU,
        //     normovanyUrok: normovanyUrok,
        //     koeficient: koeficient,
        //     minUkazatel: minUkazatel,
        //     kod: kod,
        //     poplatekSS: poplatekSS,
        //     poplatekPU: poplatekPU,
        //     vedeniUctuSS: vedeniUctuSS,
        //     vedeniUctuPU: vedeniUctuPU,
        //     vypisSS: vypisSS,
        //     vypisPU: vypisPU,
        //     C22: C22
        // }]);

        var modelSS = getModelSS({
            sazbaSS,
            poplatekSS,
            CC,
            dosporovani: realneDosporovani,
            minUkazatel,
            normovanyUrok,
            koeficient,
            preklopeni,
            vedeniUctuSS,
        })

        var sumW = 0
        var sumZ = 0
        var sumAB = 0
        modelSS.forEach(function (item) {
            sumW += item.W !== null ? item.W : 0
            sumZ += item.Z !== null ? item.Z : 0
            sumAB += item.AB !== null ? item.AB : 0
        })
        sumW *= 0.85
        vyplata = sumAB

        var modelRSTS = getModelRSTS({
            modelSS,
            CC,
            poplatekPU,
            sazbaPU,
            splatkaPU,
            vedeniUctuSS,
            vedeniUctuPU,
            vyplata,
            sazbaSU,
            splatkaSU,
        })

        // console.table(modelSS);
        // console.table(modelRSTS);

        return {
            uver: CC,
            splatkaPU: splatkaPU,
            uzivatelskaSplatkaPU: uzivatelskaSplatkaPU,
            sazbaPU: sazbaPU,
            delka: Math.max.apply(
                null,
                modelRSTS.map(function (row) {
                    return row.D
                }),
            ),
            ...this.calcMinimalIncome({
                splatka: uzivatelskaSplatkaPU,
                CC,
            }),
        }
    }

    calcMinimalIncome({ splatka, CC }) {
        // minimalni prijem
        const DSTI = splatka / this.type[this.options.type].dstiKoef
        const DTI = CC / (this.type[this.options.type].dtiKoef * 12)

        const income = Math.round(Math.max(13000, DSTI, DTI))
        const pledge = CC / this.type[this.options.type].pledge

        return {
            income,
            pledge,
        }
    }
}

function ceil10(x, n) {
    return Math.ceil(x / n) * n
}
